import React from 'react';
import styled from 'styled-components';
import { FaSortDown } from 'react-icons/fa';

import { HALF_CONTRAST } from '../theme';

const Select = styled.select`
  width: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 12px;
  border-radius: 3px;
  border: 1px solid black;
  margin-top: 0;
  font-size: 16px;
  height: auto;
  font-family: 'Montserrat', 'Open Sans', sans-serif;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const Option = styled.option`
  color: ${HALF_CONTRAST};
`;

const DownArrow = styled(FaSortDown)`
  color: ${HALF_CONTRAST};
  position: absolute;
  top: 12px;
  right: 12px;
  pointer-events: none;
`;

const SelectContainer = styled.div`
  margin-right: 16px;
  position: relative;
`;

const noop = () => {};

export const Picker = ({
  placeholder = 'Pick a filter',
  options,
  onChange = noop,
  value,
}) => (
    <SelectContainer>
      <Select value={value} onChange={onChange} placeholder={placeholder}>
        {options.map((option) => (
            <Option value={option.value} key={option.label}>
              {option.label}
            </Option>
          ))}
      </Select>
      <DownArrow />
    </SelectContainer>
  );
